<template>
    <Select
        v-model="str"
        :size="size"
        :transfer="transfer"
        :placeholder="placeholder"
        :disabled="disabled"
        :clearable="true"
        @on-change="callback"
    >
        <Option
            v-for="item in list"
            :value="item[type.value]"
            :key="item[type.value]"
        >{{ item[type.label] }}</Option>
    </Select>
</template>
<script>
import { eqObj } from '@/libs/fn.js';
export default {
    name: 'selectes',
    props: {
        value: {
            type: [String, Number, Array],
            default: ''
        },
        type: {
            type: Object,
            default: () => ({ label: 'label', value: 'value' })
        },
        size: {
            type: String,
            default: 'default'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        vertical: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        url: {
            type: String,
            default: ''
        },
        query: {//
            type: Object,
            default: () => ({})
        },
        transfer: {
            type: Boolean,
            default: true
        },
    },
    data () {
        return {
            str: '',
            arr: [],
            list: [],
            cQuery: {},
            corporation: this.$store.state.user.user.corporation || ''
        }
    },
    watch: {
        'value' (value) {
            this.getVal(value)
        },
        'query' (obj) {
            if (!eqObj(obj, this.cQuery)) {
                this.cache(obj);
                this.getList();
            }
        }
    },
    mounted () {
        this.getVal(this.value);
        this.cache(this.query);
        this.getList();
    },
    methods: {
        cache (obj) { this.cQuery = obj },
        getVal (val) {
            this.str = val;
        },
        getList () {
            var query = Object.assign({}, { corporation: this.corporation }, this.query);
            this.$ajax.post(this.url, query).then(data => {
                if (data.status == this.$ajax.HTTP_S) {
                    this.list = data.result;
                }
            });
        },
        callback (v) {
            if (v) {
                const i = this.list.findIndex(item => item[this.type.value] === v);
                this.$emit('callback', this.list[i]);
            } else {
                this.$emit('callback', v);
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/inc/dictionary/selectes.vue